<template>
	<CCol md="12" class="m-0 p-0">
		<CRow>
			<CCol md="4">
				<BaseDropDown
					:value="categoryParentLevelOne"
					:options="categoryParentLevelOneOptions"
					:searchable="false"
					:allow-empty="false"
					label="name"
					label-drop-down="Category level1"
					track-by="value"
					class="select-custom"
					data-test-id="category-lv-1"
					@input="handleSelectedCategory"
				/>
			</CCol>
			<CCol md="4">
				<BaseDropDown
					:value="categoryParentLevelTwo"
					:options="categoryParentLevelTwoOptions"
					:searchable="false"
					:allow-empty="false"
					:disabled="!categoryParentLevelTwoOptions.length"
					:placeholder="allOptionSubcategoriesLabel"
					label="name"
					label-drop-down="Category level2"
					track-by="value"
					class="select-custom"
					data-test-id="category-lv-2"
					@input="handleSelectedCategory"
				/>
			</CCol>
			<CCol md="4">
				<BaseDropDown
					:value="categoryParentLevelThree"
					:options="categoryParentLevelThreeOptions"
					:searchable="false"
					:allow-empty="false"
					:disabled="!categoryParentLevelThreeOptions.length"
					:placeholder="allOptionSubcategoriesLabel"
					label="name"
					label-drop-down="Category level3"
					track-by="value"
					class="select-custom"
					data-test-id="category-lv-3"
					@input="handleSelectedCategory"
				/>
			</CCol>
		</CRow>
	</CCol>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'ProductFilterCategory',
	props: {
		categoryId: {
			type: [String, Number],
			default: null,
		},
	},
	data() {
		return {
			allOptionSubcategoriesLabel: 'All sub-categories',
		};
	},
	computed: {
		...mapState('categoryList', {
			categoriesList: 'data',
		}),
		categoryParentLevelOneOptions() {
			const allOption = { name: 'All categories', value: null };
			const list = this.categoriesList.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});

			return [allOption, ...list];
		},
		categoryParentLevelTwoOptions() {
			let items = [];

			if (this.isLevelNumber === 1) {
				const cateId = this.categoryId;
				items = this.getChildItems(cateId);
			} else if (this.isLevelNumber === 2) {
				const cateId = this.getParentId(this.categoryId);
				items = this.getChildItems(cateId);
			} else if (this.isLevelNumber === 3) {
				const cateId = this.getParentId(this.getParentId(this.categoryId));
				items = this.getChildItems(cateId);
			}

			return items.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});
		},
		categoryParentLevelThreeOptions() {
			let items = [];

			if (this.isLevelNumber === 2) {
				const cateId = this.categoryId;
				items = this.getChildItems(cateId);
			} else if (this.isLevelNumber === 3) {
				const cateId = this.getParentId(this.categoryId);
				items = this.getChildItems(cateId);
			}

			return items.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});
		},
		categoryParentLevelOne() {
			let cateId = -1;

			if (this.isLevelNumber === 1) {
				cateId = this.categoryId;
			} else if (this.isLevelNumber === 2) {
				cateId = this.getParentId(this.categoryId);
			} else if (this.isLevelNumber === 3) {
				cateId = this.getParentId(this.getParentId(this.categoryId));
			}

			if (this.categoriesList.length) {
				const item = this.categoriesList.find((_) => _.id === Number(cateId));
				if (item) {
					return {
						name: item.name,
						value: item.id,
					};
				}
			}

			return {
				name: 'All categories',
				value: null,
			};
		},
		categoryParentLevelTwo() {
			let cateId = -1;
			let items = [];

			if (this.isLevelNumber === 2) {
				const parentLv1 = this.getParentId(this.categoryId);
				cateId = this.categoryId;
				items = this.getChildItems(parentLv1);
			} else if (this.isLevelNumber === 3) {
				const parentLv1 = this.getParentId(this.getParentId(this.categoryId));
				cateId = this.getParentId(this.categoryId);
				items = this.getChildItems(parentLv1);
			}

			if (items.length) {
				const item = items.find((_) => _.id === Number(cateId));
				if (item) {
					return {
						name: item.name,
						value: item.id,
					};
				}
			}

			return null;
		},
		categoryParentLevelThree() {
			let cateId = -1;
			let items = [];

			if (this.isLevelNumber === 3) {
				const parentLv2 = this.getParentId(this.categoryId);
				cateId = this.categoryId;
				items = this.getChildItems(parentLv2);
			}

			if (items.length) {
				const item = items.find((_) => _.id === Number(cateId));
				if (item) {
					return {
						name: item.name,
						value: item.id,
					};
				}
			}

			return null;
		},
		isLevelNumber() {
			return this.getLevel(this.categoryId);
		},
	},

	methods: {
		getParentId(cateId) {
			for (let i = 0; i < this.categoriesList.length; i++) {
				if (this.categoriesList[i].id === Number(cateId)) {
					return null;
				}
				for (let j = 0; j < this.categoriesList[i].children.length; j++) {
					if (this.categoriesList[i].children[j].id === Number(cateId)) {
						return this.categoriesList[i].id;
					}
					for (let k = 0; k < this.categoriesList[i].children[j].children.length; k++) {
						if (this.categoriesList[i].children[j].children[k].id === Number(cateId)) {
							return this.categoriesList[i].children[j].id;
						}
					}
				}
			}
			return null;
		},
		getLevel(cateId) {
			for (let i = 0; i < this.categoriesList.length; i++) {
				if (this.categoriesList[i].id === Number(cateId)) {
					return 1;
				}
				for (let j = 0; j < this.categoriesList[i].children.length; j++) {
					if (this.categoriesList[i].children[j].id === Number(cateId)) {
						return 2;
					}
					for (let k = 0; k < this.categoriesList[i].children[j].children.length; k++) {
						if (this.categoriesList[i].children[j].children[k].id === Number(cateId)) {
							return 3;
						}
					}
				}
			}
			return -1;
		},
		getChildItems(cateId) {
			for (let i = 0; i < this.categoriesList.length; i++) {
				if (this.categoriesList[i].id === Number(cateId)) {
					return this.categoriesList[i].children;
				}
				for (let j = 0; j < this.categoriesList[i].children.length; j++) {
					if (this.categoriesList[i].children[j].id === Number(cateId)) {
						return this.categoriesList[i].children[j].children;
					}
					for (let k = 0; k < this.categoriesList[i].children[j].children.length; k++) {
						if (this.categoriesList[i].children[j].children[k].id === Number(cateId)) {
							return [];
						}
					}
				}
			}
			return [];
		},
		handleSelectedCategory({ value }) {
			this.$emit('onCategoryChange', value);
		},
	},
};
</script>
